module.exports = __webpack_public_path__ + "img/E1E1E0_363636_989897_747472-256px.3e61ca9f.png";